

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import actualidadModule from '@/store/actualidad'
import formulariosModule from '@/store/formularios'
import destacadosModule from '@/store/destacados'
import ficherosModule from '@/store/ficheros'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';

import messages from '@/translations';

import appinfo from '../../package.json';


export const store = new Vuex.Store({
  state :{
    language: localStorage.getItem('language') || 'es',
    server : 'https://back.carrerasprofesionales-ufv.es/',
    packageVersion : appinfo.version
  },
  actions :{
    changeLanguage : ({commit}, actualLang) => {
      return new Promise((resolve, reject) => {
        let nextLang = (actualLang == "es") ? "en" : "es";
        commit('setLanguage', nextLang);
        switch (nextLang) {
          case "es":
          Validator.localize('es', validatorEs);
          break;
          case "en":
          Validator.localize('en', validatorEn);
          break;
        }
        resolve(nextLang);
      });
    },
    initApp:({commit,dispatch}) => {
      dispatch('requestNoticias');
      dispatch('requestEventos');
      dispatch('requestDestacados');
      dispatch('requestRecursos');
    }
  },
  getters : {
    getVersion : state => state.packageVersion,
    getLanguage : state => state.language,
    getServer : state => state.server,
    getTexts : state => {
      return messages[state.language];
    }
  },
  mutations : {
    setLanguage (state, lang){
      state.language = lang;
      localStorage.setItem('language', lang);      
    }
  },
  modules :{
    actualidadModule,
    formulariosModule,
    destacadosModule,
    ficherosModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js